import { Controller } from '@hotwired/stimulus';
import { paint } from '../lib/dom';

export default class extends Controller {
  static targets = ['changesSegment', 'count', 'filesSegment'];

  static classes = ['segmentActive', 'segmentIdle'];

  update({ detail: { count } }) {
    this.element.hidden = count === 0;
    this.countTarget.textContent = count;

    if (count === 0) this.showFiles();
  }

  showFiles() {
    this.#switch('files');
  }

  showChanges() {
    this.#switch('changes');
  }

  #switch(mode) {
    const files = mode === 'files';

    this.#paint(this.filesSegmentTarget, files);
    this.#paint(this.changesSegmentTarget, !files);

    this.dispatch('mode', { target: window, detail: { mode } });
  }

  #paint(segment, active) {
    segment.setAttribute('aria-pressed', String(active));
    paint(segment, active, this.segmentActiveClasses, this.segmentIdleClasses);
  }
}
